import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Type,
  Flex,
  useMediaQuery,
} from "discover.medical.react-component-library";
import { TabsHeader, LinksSet } from "../../components/AlphaTabsNavigation";
import NarrowFilter from "../../components/NarrowFilter";
import PopulationFilter from "../../components/PopulationFilter";
import { PageTitle, PageDescription } from "../../components";
import useSets from "../../hooks/useSets";
import useTabsAndLinks from "../../hooks/useTabsAndLinks";
import useStickyElement from "../../hooks/useStickyElement";
import { setQueryString, getQueryParam } from "../../util/queryParamUtils";
import qs from "qs";
import { Sticky } from "../../components/Sticky/_.styled";
import { useSearch } from "../../hooks/useSearch";

const DiseasesAndConditions = ({ title, description, topics }) => {
  const stickyWrapperId = "stickyContainerTab";
  const diseaseAndConditionRootElementId = "diseases-and-conditions-root";

  const populationFilterOptions = [
    "All Diseases & Conditions",
    "Pediatric",
    "Adult",
  ];
  let isInitialMount = useRef(true);
  const history = useHistory();

  const populationTypeFilterQSValue = getQueryParam(history, "populationType");
  const currentDropdownIndex = populationTypeFilterQSValue
    ? populationFilterOptions.indexOf(populationTypeFilterQSValue)
    : 0;
  const initialSearchKey = qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  }).searchKey;
  const {
    searchTerm: searchKey,
    handleSearchTermChange: handleSearchKeyChange,
    searchUtils,
  } = useSearch(initialSearchKey);
  const [options] = useState(populationFilterOptions);
  const [populationFilterIndex, setPopulationFilterIndex] = useState(
    currentDropdownIndex
  );
  const [populationSelectedItem, setPopulationSelectedItem] = useState(
    populationFilterOptions[currentDropdownIndex]
  );
  const { isElementSticky } = useStickyElement();
  const { recordsSets } = useSets(topics);

  useEffect(() => {
    const searchKeyValue = searchKey || undefined;
    const populationTypeValue =
      populationSelectedItem &&
      populationSelectedItem !== "All Diseases & Conditions"
        ? populationSelectedItem
        : undefined;

    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setQueryString(
        history,
        ["searchKey", searchKeyValue],
        ["populationType", populationTypeValue]
      );
    }
  }, [searchKey, populationSelectedItem, history]);

  const { tabs, linksSets } = useTabsAndLinks({
    recordsSets,
    populationFilterIndex,
    populationSelectedItem,
    searchKey,
  });

  const populationChangeHandler = (index, fieldTitle) => {
    setPopulationFilterIndex(index);
    setPopulationSelectedItem(fieldTitle);
  };

  const smMq = useMediaQuery("min", "sm");
  return (
    <>
      <PageTitle
        id={diseaseAndConditionRootElementId}
        data-testid="diseases-and-conditions-header"
      >
        {title}
      </PageTitle>
      <PageDescription data-testid="diseases-and-conditions-description">
        {description}
      </PageDescription>
      <Sticky
        id={stickyWrapperId}
        data-testid="sticky-container"
        sticky={isElementSticky}
      >
        <TabsHeader
          itemsList={tabs}
          StickyWrapperId={stickyWrapperId}
          RootElement={diseaseAndConditionRootElementId}
        />

        <Flex container justify={{ content: "flex-start" }}>
          <Flex column={!smMq} cell span={12}>
            <NarrowFilter value={searchKey} onChange={handleSearchKeyChange} />
            <PopulationFilter
              options={options}
              handleChange={populationChangeHandler}
            />
          </Flex>
        </Flex>
      </Sticky>

      <div data-testid="linksSet">
        {!!linksSets?.length ? (
          linksSets.map((item, index) => (
            <LinksSet {...item} searchUtils={searchUtils} key={index} />
          ))
        ) : (
          <Type element="i" fontSize="sm" color="gray600">
            No disease & condition matches for the term provided
          </Type>
        )}
      </div>
    </>
  );
};

export default DiseasesAndConditions;
